      document.addEventListener('DOMContentLoaded', function() {
        // 1秒の遅延を追加
        setTimeout(function() {
          // 指定されたクラス名を持つすべての要素を取得
          var elements = document.getElementsByClassName('vip-app-referral-code-block_code');

          // 各要素にスタイルを適用
          for (var i = 0; i < elements.length; i++) {
            elements[i].style.marginBottom = '20px';
            elements[i].style.fontWeight = '600';
          }
        }, 1000); // 1000ミリ秒（1秒）の遅延
      });